import type { CaseDetail } from '../portfolio';

const remoCartCase: CaseDetail = {
  id: 'remo-cart',
  project: 'REMO CART',
  client: 'クリエイトSD',
  year: '2022',
  category: 'Service Brand / App / Retail',
  role: 'Service Design / Brand Strategy / CX Planning',
  issue: '買い物体験のなかで、荷物運搬という課題が生活者の手間として放置されていた。',
  challenge: '「かご」という日常の道具を、より楽で快適な買い物体験の起点として再定義すること。',
  insight: '「あなたに代わって、集めておきます。」—— 単なる運搬道具ではなく「買い物を楽しくする伴走者」として捉え直すと、価値が広がる。',
  strategy: 'REMO CART というサービスブランドを立ち上げ、「あなたに代わって、集めておきます」というコミュニケーションコンセプトで、アプリと実店舗の買い物体験を接続。',
  experience: 'アプリの操作性、店舗での導線、返却体験まで、買い物の全プロセスを設計。',
  output: 'Service Design / Brand / App UI / Retail Touchpoint / Communication',
  impact: '買い物の負担軽減と、新しい買い物体験の価値提示を実現。',
  images: [
    {
      src: '/assets/migrated/90b0d4db2fc0f07d7c5d.webp',
      caption: 'デザインイメージ（媒体展開例）— 縦組み・横組みデザイン',
    },
    {
      src: '/assets/migrated/42ca242f42a58aa6c4ad.webp',
      caption: 'アプリアイコン — iOS / Android',
    },
    {
      src: '/assets/migrated/52176df8c81e165fdc6c.webp',
      caption: 'ブランドビジュアル — キービジュアルとロゴ展開',
    },
    {
      src: '/assets/migrated/8cb3248544039e3911ce.webp',
      caption: 'ヒッポちゃん（リモカートver.）— メイン / サブ',
    },
    {
      src: '/assets/migrated/7ab7259c4e542f667681.webp',
      caption: 'サイネージ動画 / 買物カート装飾 / バナー類 / アプリ用マップ',
    },
    {
      src: '/assets/migrated/2e954c4da70000fb47b1.webp',
      caption: 'サイネージ動画 / 買物カート装飾 / バナー類 / アプリ用マップ',
    },
    {
      src: '/assets/migrated/c7a3000044d0abf2a384.webp',
      caption: 'REMO CART 制作用ガイドライン表紙',
    },
    {
      src: '/assets/migrated/8e292c771de53c9f835a.webp',
      caption: 'A3ポスター / A6リーフレット / 利用シーン / LP / スタッフビブス 展開イメージ',
    },
    {
      src: '/assets/migrated/3f35c44628ab255e9ca5.webp',
      caption: 'デザインイメージ B案（媒体展開案）— 縦組み・横組みデザイン',
    },
    {
      src: '/assets/migrated/28d1beb6040f14426d27.webp',
      caption: 'アプリアイコン案②（ロゴレギュレーションB案）・案③（キャラクター案）/ LP導線設計 / 店頭ツール案',
    },
    {
      src: '/assets/migrated/a826e4cbeab760d92c03.webp',
      caption: 'REMO CART 制作用ガイドライン / ヒッポちゃん（リモカートver.）/ ロゴレギュレーション / ルックデザイン',
    },
    {
      src: '/assets/migrated/5967985ccb266cc06dc6.webp',
      caption: '店頭ツール展開 — カラーコーン / 案内のぼり / スタッフウェア（ビブス）',
    },
    {
      src: '/assets/migrated/0f606e03f8adde964eae.webp',
      caption: 'コミュニケーションコピー・KV A案（LPトップページ）— あなたに代わって、集めておきます。',
    },
    {
      src: '/assets/migrated/b29a94c6896860884a23.webp',
      caption: 'デザインイメージ ① — アプリアイコン・ブランドビジュアル・キービジュアル・LP展開',
    },
    {
      src: '/assets/migrated/02d8781ada77c1091f60.webp',
      caption: 'ロゴレギュレーション案 — タテ組み・ヨコ組み・白抜き・ダーク背景',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption: 'KV（LPトップページ）— あなたに代わって、集めておきます',
    },
    {
      src: '/assets/migrated/9c21b625073ce5356801.webp',
      caption: 'アプリ画面と店頭リーフレット — 実際の利用シーン',
    },
    {
      src: '/assets/migrated/0d7414fc2dbd2feb5859.webp',
      caption: 'REMO CART デザインコンセプト — ロゴレギュレーション・KV・媒体展開案',
    },
    {
      src: '/assets/migrated/8290d7cc6d4ff0f4eb11.webp',
      caption: 'コミュニケーションコピー・KV B案 — サービス訴求展開',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption: 'ロゴレギュレーション — タテ組み・ヨコ組み・白抜き・ダーク背景',
    },
    {
      src: '/assets/migrated/2ad11bb2272f1b9d3740.webp',
      caption: 'REMO CART ブランドキービジュアル — 「あなたに代わって、集めておきます。」 ヒッポチャン・ロゴ・コミュニケーション実績',
    },
    {
      src: '/assets/migrated/1c5acb7323cd12f7eeba.webp',
      caption: 'デザインイメージ A案（媒体展開案）— 縦組み・横組みデザイン',
    },
    {
      src: '/assets/migrated/6eaea41ce66ade1a7b74.webp',
      caption: 'アプリ画面と店頭リーフレット — 実際の利用シーン ②',
    },
  ],
  videos: [
    {
      src: '/assets/migrated/6724b8625e5a6ff9f171.mp4',
      caption: 'REMO CART プロモーション映像',
    },
  ],
};

export default remoCartCase;